
function _getStatusMessage (status) {
  switch (status) {
    case 401:
      return  'البريد الإلكتروني أو كلمة السر غير صحيحة.'
    case 403:
      return  'ليس لديك الصلاحيات لهذه العملية.'
    case 404:
      return  'العملية غير موجوده.'
    case 422:
      return  'الرجاء التأكد من صحة البيانات.'
    case 500:
      return  'حدث خطأ في الخادم.'
    case 503:
      return  'الخادم غير متوفر.'
    default:
      return  'حدث خطأ الرجاء إعادة المحاولة.'
  }
}

function _getSuccessMessage(name, type) {
  switch (type) {
    case 'add':
      return `تمت إضافة ${name} بنجاح.`
    case 'update':
      return `تم تعديل ${name} بنجاح.`
    case 'delete':
      return `تم حذف ${name} بنجاح.`
    default:
      return 'تمت العملية بنجاح.'
  }
}

/**
 * Create instant, which represent response object
 * @param {Object} [response] - axios response object
 * @param {String} [name] - name of the entity
 * @param {String} [type] - type of operation
 * @param {Object} [data] - custom data to display
 */
export class ResponseWrapper {
  constructor(response, name, type, data){
    this.response = response
    this.data = data ? data : response.data
    this.successMessage = _getSuccessMessage(name, type)
  }
}

/**
 * Create instant, which represent error object
 * @param {Object} [error] - axios error object
 * @param {String} [message] - custom message to display
 */
export class ErrorWrapper extends Error {
  constructor ({response}) {
    super()
    this.stack = new Error().stack
    this.errors = response ? response.data.errors : undefined
    this.error = response ? response.data.error : undefined
    this.status = response ? response.status : undefined
    this.message = response ? response.data.message : undefined
    this.statusMessage = _getStatusMessage(this.status)

    /*  this is for return backend validation to the front
        and wrap it with ( field, msg ) to assign it to VeeValidation */
    this.validationError = []
    if(this.errors){
      Object.keys(this.errors).forEach(key => {
        this.validationError.push({
          field: key,
          msg: this.errors[key][0]
        })
      })
    }
  }
}
